import { gql } from "@apollo/client";

export const UPLOAD_RELATIONSHIPS = gql`
  mutation UploadRelationships(
    $relationships: [relationship_person_insert_input!]!
  ) {
    insert_relationship_person(objects: $relationships) {
      affected_rows
    }
  }
`;

export const BULK_UPLOAD_PEOPLE = gql`
  mutation BulkUploadPeople($people: [person_insert_input!]!) {
    insert_person(objects: $people) {
      affected_rows
    }
  }
`;

export const DELETE_DOCUMENT_ITEM = gql`
  mutation DeleteDocumentItem($document_id: uuid!) {
    update_document_metadata_by_pk(
      pk_columns: { document_id: $document_id }
      _set: { deleted_at: "now()" }
    ) {
      document_id
    }
  }
`;

export const INSERT_FORM_ANSWER = gql`
  mutation InsertFormAnswerOne($form_answer: form_answer_insert_input!) {
    insert_form_answer_one(
      object: $form_answer
      on_conflict: {
        constraint: form_answer_form_id_form_question_id_key
        update_columns: [updated_at]
      }
    ) {
      id
    }
  }
`;

export const UPDATE_PERSON_RELATIONSHIP = gql`
  mutation UpdatePersonRelationship(
    $first_person: uuid!
    $second_person: uuid!
  ) {
    update_relationship_person(
      _set: { active: true }
      where: {
        first_person: { _eq: $first_person }
        second_person: { _eq: $second_person }
      }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`;

export const ADD_PERSON_RELATIONSHIP = gql`
  mutation AddPersonRelationship($first_person: uuid!, $second_person: uuid!) {
    insert_relationship_person_one(
      object: {
        first_person: $first_person
        second_person: $second_person
        active: true
      }
      on_conflict: {
        update_columns: active
        constraint: relationship_person_first_person_second_person_key
      }
    ) {
      id
    }
  }
`;

export const DELETE_PERSON_RELATIONSHIP = gql`
  mutation DeletePersonRelationship($id: uuid!) {
    update_relationship_person_by_pk(
      pk_columns: { id: $id }
      _set: { active: false }
    ) {
      id
    }
  }
`;

export const DELETE_FORM_TEMPLATE = gql`
  mutation DeleteFormTemplate($id: uuid!) {
    update_form_template_by_pk(
      pk_columns: { id: $id }
      _set: { deleted_at: "now()" }
    ) {
      id
    }

    update_assigned_form(
      where: { form_template_id: { _eq: $id }, deleted_at: { _is_null: true } }
      _set: { deleted_at: "now()" }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_ENROLLMENT_PERIOD = gql`
  mutation DeleteEnrollmentPeriod($id: uuid!) {
    update_enrollment_period_by_pk(
      pk_columns: { id: $id }
      _set: { deleted_at: "now()" }
    ) {
      id
    }
    delete_school_boundary(
      where: {
        boundary_id: { _is_null: false }
        enrollment_period_id: { _eq: $id }
      }
    ) {
      affected_rows
    }
  }
`;

export const UPLOAD_APPLICANT_ATTENDING_SCHOOLS = gql`
  mutation UploadApplicantAttendingSchools(
    $data: [applicant_attending_school_insert_input!]!
  ) {
    insert_applicant_attending_school(
      objects: $data
      on_conflict: {
        constraint: applicant_attending_school_person_id_enrollment_period_id_key
        update_columns: [school_id, attendance_status, description]
      }
    ) {
      affected_rows
    }
  }
`;

export const CREATE_FORM = gql`
  mutation CreateForm($person_id: uuid!, $form_template_id: uuid!) {
    insert_form_one(
      object: {
        person_id: $person_id
        form_template_id: $form_template_id
        is_hidden_from_parent: false
        status: InProgress
      }
    ) {
      id
      status
      is_hidden_from_parent
    }
  }
`;
